// extracted by mini-css-extract-plugin
export default {"tamano":"Calendar_tamano__zCHi2"};